module.exports = __webpack_public_path__ + "static/media/bg99select1.01339a42.png";